import { ReactComponent as CallIcon } from 'assets/icons/call/call.svg';

export const call = {
  call: CallIcon,
};
